import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14a3904f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-background" }
const _hoisted_2 = { class: "tradist-container" }
const _hoisted_3 = { class: "token__wrapper" }
const _hoisted_4 = { class: "token__details" }
const _hoisted_5 = { class: "token__details--content" }
const _hoisted_6 = { class: "text-2xl text-white font-bold mb-5" }
const _hoisted_7 = {
  key: 0,
  class: "inline-block text-4xl text-primary-default mb-5 font-bold"
}
const _hoisted_8 = { class: "text-4xl text-white font-bold mb-6" }
const _hoisted_9 = { class: "text-sm text-white mb-9" }
const _hoisted_10 = { class: "text-xl text-white" }
const _hoisted_11 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "list__currency" }, " ETH ", -1))
const _hoisted_13 = { class: "preview__image--wrapper" }
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueNumberInput = _resolveComponent("VueNumberInput")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseToaster = _resolveComponent("BaseToaster")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.shorthenedSellerAddress(_ctx.token.owner || '')), 1),
            (_ctx.token.price)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.weiToEther(_ctx.token.price || '')) + " ETH ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.token.title), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.token.description), 1),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.tags), 1),
            (_ctx.button.text === 'List')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_VueNumberInput, {
                    modelValue: _ctx.listPrice,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listPrice) = $event)),
                    class: "w-full mr-1",
                    inline: ""
                  }, null, 8, ["modelValue"]),
                  _hoisted_12
                ]))
              : _createCommentVNode("", true),
            (_ctx.button.visible)
              ? (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 2,
                  disabled: _ctx.isButtonDisabled,
                  class: "block mt-10",
                  size: "xl",
                  fontWeight: 500,
                  fontSize: "lg",
                  shadow: "",
                  textColor: "white",
                  bgColor: "black",
                  onClick: _ctx.button.action
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.button.text), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("img", {
            class: "preview__image",
            src: _ctx.token?.asset?.path || ''
          }, null, 8, _hoisted_14)
        ])
      ])
    ]),
    _createVNode(_component_BaseToaster, {
      active: _ctx.toaster.visible,
      text: _ctx.toaster.text,
      buttonText: _ctx.toaster.buttonText,
      type: _ctx.toaster.type,
      onClick: _ctx.toaster.action
    }, null, 8, ["active", "text", "buttonText", "type", "onClick"])
  ]))
}